export default __webpack_public_path__ + "static/media/admission-rules.d7e730cc.pdf";